import classNames from "classnames"
import { useApp } from "../../../hooks/useApp"

interface Props {
  className?: string
}

export const ChainVariants = ({ className }: Props) => {
  const { 
    mainProduct: { variants }, 
    activeMainProductVariantId, 
    setActiveMainProductVariantId ,
  } = useApp()

  return (
    <ul className={classNames("flex items-center gap-3 overflow-x-auto", className)}>
      {variants.map(variant => {
        const { id, title, featuredImageUrl } = variant

        const handleClick = () => {
          setActiveMainProductVariantId(id)
        } 

        const isActive = id === activeMainProductVariantId

        return (
          <li key={id} className="shrink-0">
            <button 
              className={classNames(
                "border border-subdued rounded-sm", 
                isActive && "border-solid"
              )}
              onClick={handleClick} 
            > 
              <img 
                className="w-[80px] h-[100px] object-cover"
                src={featuredImageUrl}
                alt={title}
                width="40"
                height="50"
              />
            </button>
          </li>
        )
      })}
    </ul>
  )
}